export default {
  back_to_login: 'Volver al inicio de sesión',
  confirm_new_password: 'Confirmar contraseña',
  confirm_new_password_error: 'Asegúrese de que sus contraseñas coinciden.',
  form_description: 'Escriba su nombre de usuario y dirección de correo electrónico para restablecer su contraseña.',
  form_title: '¿Olvidó su contraseña?',
  new_password: 'Nueva contraseña',
  new_password_error: '{{fieldName}} debe cumplir con las politicas de contraseñas.',
  otp_reset_invalid_error: 'Lo sentimos! El código de verificación no es válido o ha caducado.',
  page_title: '{{realmName}} - ¿Olvidó su contraseña?',
  pre_reset_invalid_error: 'Lo sentimos! El nombre de usuario no existe o el correo electrónico no es válido.',
  reset_password: 'Restablecer contraseña',
  reset_password_description: 'Escriba su nueva contraseña para  su cuenta.',
  reset_password_title: 'Restablezca tu contraseña',
  success_description: 'Genial, ha restablecido correctamente su contraseña.',
  success_title: 'Contraseña restablecida',
  verification_code: 'Código de Verificación',
  verification_code_title: 'Código de Verificación',
  verification_eotp_code_description: 'Escriba el código de verificación que enviamos al correo {{email}}.',
  verification_sotp_code_description: 'Escriba el código de verificación que enviamos al móvil terminado en {{hint}}.',
};